import { DataService } from "./data";
import { ApiLibsFn } from "../libs/host";
import { UtilLibs } from "../libs/utils";
import { OpenService } from "./open";
import { md } from '../winform';
export class AdvertsService {
    /**
     * 查询广告
     * @param type
     * @param limit
     * @returns
     */
    static async queryAdverts(params) {
        let urlParams = "";
        Object.keys(params).forEach((item, index) => {
            // @ts-ignore
            urlParams =
                // @ts-ignore
                urlParams + (index === 0 ? "?" : "&") + item + "=" + params[item];
        });
        const advs = await DataService.get(`${ApiLibsFn().Api81}/adverts/queryAdverts${urlParams}`);
        if (advs) {
            this.viewAdverts(advs.map((item) => item.advId));
        }
        return advs || [];
    }
    /**
     * 查询广告 - 分页
     * @param type
     * @param page
     * @param pageSize
     * @param isView 是否记录一次曝光
     * @returns
     */
    static async getAdvertsList(type, page = 1, pageSize = 10, isView = false) {
        const pageRes = await DataService.get(`${ApiLibsFn().Api81}/adverts/getAdvertsList?page=${page}&pageSize=${pageSize}&type=${type}`);
        if (pageRes && pageRes.content && isView) {
            this.viewAdverts(pageRes.content.map((item) => item.advId));
        }
        return pageRes;
    }
    /**
     * 展示广告
     */
    static async viewAdverts(advIds = []) {
        if (!advIds || advIds.length <= 0) {
            return false;
        }
        let urlParams = "";
        advIds.forEach((item, index) => {
            urlParams = urlParams + `${index === 0 ? "?" : "&"}advIds=${item}`;
        });
        return await DataService.post(`${ApiLibsFn().Api81}/adverts/viewAdverts${urlParams}`);
    }
    /**
     * 点击广告
     * @param advId
     * @returns
     */
    static async clickAdverts(advId) {
        return await DataService.post(`${ApiLibsFn().Api81}/adverts/clickAdverts?advId=${advId}`);
    }
    /**
     * 打开广告详情页（新的）
     * @param advId
     * @param url
     */
    static openAdvertInfo(advId, url) {
        const urlConfig = UtilLibs.getUrlParamObj(url);
        const { type, id } = urlConfig;
        this.clickAdverts(advId);
        switch (type) {
            case "company":
                OpenService.openCompDetail(id);
                break;
            case "product":
                OpenService.openProdDetails(id);
                break;
            default:
                url.startsWith('http') && md.openUrl(url);
                break;
        }
    }
}
